import {observable} from 'mobx';
import computed from 'lib/mobx/computed';
import decorator from 'lib/lang/decorator';

export default decorator(() => Class => {
    class Likeable extends Class {
        userStore: UserStore;

        @observable likerIds;
        toggleLikePromise;

        constructor(options) {
            super(options);
            const {userStore} = options;
            this.userStore = userStore;
        }

        @computed get likesCount() {
            if (!this.likerIds) {
                return 0;
            }

            return this.likerIds.length;
        }

        @computed get isLikedByMe() {
            if (!this.userStore.me || !this.likerIds) {
                return false;
            }

            return this.likerIds.indexOf(this.userStore.me.id) > -1;
        }

        loadLikes() {
            return this.delegate.loadLikes({likeable: this});
        }

        toggleLike() {
            const id = this.userStore.me.id;
            const previous = [...this.likerIds];

            if (this.toggleLikePromise && this.toggleLikePromise.isPending()) {
                this.toggleLikePromise.cancel();
            }

            let promise;

            if (this.isLikedByMe) {
                this.likerIds.remove(id);
                promise = this.delegate.unlike({likeable: this});
            } else {
                this.likerIds.push(id);
                promise = this.delegate.like({likeable: this});
            }

            promise.finally(() => {
                if (promise.isCancelled() || promise.isRejected()) {
                    this.likerIds = previous;
                }
            });

            this.toggleLikePromise = promise;
            return promise;
        }
    }

    return Likeable;
});

